<div class="row h-100 flex-lg-nowrap">
  <div class="col-lg-4 col-md-12 col-md-4 col-xxl-3 h-100 mb-3 mb-lg-0">
    <div class="card shadow-sm rounded-4 border h-100 overflow-hidden">
      <div class="card-body d-flex flex-column h-100">
        <!-- Header -->
        <div class="d-flex align-items-center justify-content-between mb-3">
          <h2 class="fw-500 mb-0 fs-24">Available Crafts</h2>
        </div>

        <!-- Search -->
        <div class="position-relative mb-3">
          <svg-icon
            [name]="'search-topbar'"
            class="position-absolute top-50 translate-middle-y ms-3 svg-24 svg-primary"
          ></svg-icon>
          <input
            type="text"
            placeholder="Search craft code or desc."
            class="form-control form-control-lg ps-5 rounded-5"
            [(ngModel)]="search"
          />
        </div>
        <!-- Product List -->
        <div class="bg-light d-flex flex-column flex-fill gap-3 mb-n3 me-n3 mx-n3 overflow-y-auto p-3 pb-3 pe-3">
          <!-- Product Card (Selected Example) -->
          <div class="row gy-3">
            @for (craftEntity of craftEntitiesList(); track $index) {
              <div class="col-md-6 col-lg-12">
                <lib-product-crafts-preview-card
                  [craftEntity]="craftEntity"
                  (openCraftModal)="selectedCraftId.set($event); openAddCraftModal()"
                ></lib-product-crafts-preview-card>
              </div>
            }
          </div>
          @if (craftEntitiesList().length === 0) {
            <div class="d-flex flex-column align-items-center justify-content-center gap-2 h-100">
              <i class="bi bi-bag fs-48 text-gray-300"></i>
              <p class="mb-0 fs-20 text-gray-300">No crafts found.</p>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="col col-lg col-md-12 h-100">
    <div class="rounded-4 bg-white border p-3 attribute-card d-flex flex-column h-100">
      <h2 class="mb-3">Added Crafts</h2>

      <div class="flex-fill h-100 overflow-hidden">
        <div class="table-outer table-theme">
          <div class="table-responsive h-100">
            <p-table [value]="productCraftsList()">
              <ng-template #header>
                <tr>
                  <th pSortableColumn="craft.code" pSortableColumn="craft.code">
                    Craft Code <p-sortIcon field="craft.code"></p-sortIcon>
                  </th>
                  <th pSortableColumn="craft.type" pSortableColumn="craft.type">
                    Craft Type <p-sortIcon field="craft.type"></p-sortIcon>
                  </th>
                  <th>Description</th>
                  <th>PO Description</th>
                  <th>Task Code</th>
                  <th class="text-center">Exclude From Global Markup</th>
                  <th width="50" alignFrozen="right" pFrozenColumn [frozen]="true" class="bg-inherit"></th>
                </tr>
              </ng-template>
              <ng-template #body let-productCraft>
                <tr>
                  <td>{{ productCraft.craft.code }}</td>
                  <!-- <td>{{ productCraft.craft.type | enumToString: CraftTypeEnum }}</td> -->
                  <td>{{ CraftTypeEnum[productCraft.craft.type] }}</td>
                  <td>{{ productCraft.craft.description }}</td>
                  <td>{{ productCraft.poDescription }}</td>
                  <td>{{ productCraft.task?.taskCode }}</td>
                  <td class="text-center">
                    <i
                      class="bi"
                      [ngClass]="
                        productCraft.excludeFromGlobalMarkup
                          ? 'bi-check-circle-fill text-success'
                          : 'bi-x-circle-fill text-danger'
                      "
                    ></i>
                  </td>
                  <td>
                    <div ngbDropdown container="body">
                      <svg-icon [name]="'menu-dots'" class="svg-24" ngbDropdownToggle></svg-icon>
                      <div ngbDropdownMenu>
                        <button
                          class="dropdown-item"
                          (click)="
                            selectedProductCraftId.set(productCraft.id);
                            selectedCraftId.set(productCraft.craftId);
                            openAddCraftModal()
                          "
                        >
                          Edit
                        </button>
                        <button class="dropdown-item text-danger" (click)="removeProductCraft(productCraft.id)">
                          Delete
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template #emptymessage>
                <tr>
                  <td colspan="10" class="text-center">No crafts found.</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addCraftModal let-modal>
  <div class="d-flex flex-column h-100">
    <div class="modal-header pt-3">
      <h2 class="modal-title">{{ selectedProductCraftId() ? 'Edit Craft' : 'Add Craft' }}</h2>
      <span role="button" class="ms-auto" (click)="closeModal()">
        <svg-icon [name]="'modal-close-menu'" class="svg-32"></svg-icon>
      </span>
    </div>

    <div class="modal-body overflow-hidden">
      <lib-product-crafts-form
        #productCraftsForm
        [productId]="productId()"
        [selectedCraftId]="selectedCraftId()"
        [productCraftId]="selectedProductCraftId()"
        (reload)="productCrafts.reload(); selectedProductCraftId.set(null)"
      ></lib-product-crafts-form>
    </div>
    <div class="modal-footer">
      <button class="btn btn-secondary btn-h42" (click)="closeModal()">Cancel</button>
      <button class="btn btn-primary btn-h42" (click)="productCraftsForm.submitProductCraft()">
        {{ selectedProductCraftId() ? 'Update Craft' : 'Add Craft' }}
      </button>
    </div>
  </div>
</ng-template>
